import { scroll } from "motion";

export default (itemSize: number) => ({
  cancel: null,
  init() {
    this.cancel = scroll(
      (progress) => {
        // Calculate section size based on number of items
        const sectionSize = 1 / itemSize;
        // Calculate current section based on progress
        const activeSection = Math.min(
          Math.floor(progress / sectionSize),
          itemSize - 1,
        );

        if (progress > 0 && progress < 1) {
          window.Alpine.store("sticky").showNav();
        } else {
          window.Alpine.store("sticky").hideNav();
        }

        this.setActiveSection(activeSection);
      },
      {
        target: this.$root,
        offset: ["start start", "end end"],
      },
    );
  },
  setActiveSection(index: number) {
    this.$root.dataset.index = index;

    // Get all cards
    const cards = this.$root.querySelectorAll("[data-sticky-card]");

    cards.forEach((card: HTMLElement) => {
      const cardIndex = parseInt(card.dataset.stickyCard || "0");
      const distance = cardIndex - index;

      if (distance === 0) {
        // Active card
        card.style.setProperty("--scale", "1");
        card.style.setProperty("--y", "0");
        card.style.setProperty("--mobile-y", "0");
        card.style.setProperty("--opacity", "1");
        card.style.setProperty("--overlay-opacity", "0");
        card.style.setProperty("--pointer-events", "auto");
      } else if (distance > 0) {
        // Cards after active
        const scale = 1 - distance * 0.1; // Decrease by 10% each step with no minimum
        const y = `${-5 * distance}%`; // Continue stepping -5% for each position
        const mobileY = `${-4 * distance}%`; // Mobile stepping -4% for each position
        const opacity = distance === 2 ? 0.4 : distance > 2 ? 0 : 1; // Only 0.4 opacity for third position

        card.style.setProperty("--scale", scale.toString());
        card.style.setProperty("--y", y);
        card.style.setProperty("--mobile-y", mobileY);
        card.style.setProperty("--opacity", opacity.toString());
        card.style.setProperty("--overlay-opacity", "0.5");
        card.style.setProperty("--pointer-events", "none");
      } else {
        // Cards before active (already passed)
        card.style.setProperty("--scale", "1.025");
        card.style.setProperty("--y", "0");
        card.style.setProperty("--mobile-y", "0");
        card.style.setProperty("--opacity", "0");
        card.style.setProperty("--overlay-opacity", "0");
        card.style.setProperty("--pointer-events", "none");
      }
    });
  },
  destroy() {
    if (this.cancel) {
      this.cancel();
    }
  },
});
